/// <amd-module name="Repos/Tfvc/Views/ChangesetDetails/ChangesetDiscussionThreadService" />
import { ArtifactDiscussionThreadService, IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { DiscussionThreadPermissions } from "Repos/Discussion/DiscussionThread.Types";
import { getArtifactUri } from "Repos/Tfvc/Common/Utils/Changeset";
import { ITfvcChangeData, ITfvcChangeItem } from "Repos/Tfvc/Views/ChangeDetails/Contracts";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IChangesetDetailsData } from "./Contracts";

export interface IChangesetDiscussionThreadService extends IArtifactDiscussionThreadService {}

const dataProviderId = "ms.vss-code-web.tfvc-details-view-data-provider";

class ChangesetDiscussionThreadService extends ArtifactDiscussionThreadService implements IChangesetDiscussionThreadService {
    protected getArtifactUri(pageContext: IVssPageContext): string {
        const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        const changesData = contributionService.getData<ITfvcChangeData<ITfvcChangeItem>>(dataProviderId);
        const tfvcChangeDetails = changesData ? (changesData.tfvcChangeDetails as IChangesetDetailsData) : undefined;
        const changesetId = tfvcChangeDetails ? tfvcChangeDetails.changesetId : 0;

        return getArtifactUri(changesetId);
    }
    protected getPermissions(): DiscussionThreadPermissions {
        // Any valid user can do all of these
        return DiscussionThreadPermissions.ChangeStatus | DiscussionThreadPermissions.LikeComment | DiscussionThreadPermissions.ManageComment;
    }
}

const serviceName = "IChangesetDiscussionThreadService";
export function getDiscussionThreadService(pageContext: IVssPageContext): IChangesetDiscussionThreadService {
    return pageContext.getService(serviceName);
}

Services.add(serviceName, { serviceFactory: ChangesetDiscussionThreadService });
